<template>
    <div class="login-bg">
        <div class="login-left">
            <img
                v-if="$store.state.clientele.imageAddress"
                :src="$store.state.clientele.imageAddress"
                alt=""
            />
            <img v-else src="../../../static/images/logo-white.png" alt="" />
            <div class="clienteleName">
                {{ $store.state.clientele.appletName }}
            </div>
            <div class="login-copyright">Copyright 2019 长春市把手科技有限公司</div>
            <div class="login-info">
                <div class="login-info-title">
                    {{ $store.state.clientele.displayName }}
                </div>
                <div class="login-info-text">{{ $store.state.clientele.slogan }}</div>
            </div>
        </div>
        <div class="login-right">
            <div class="login-box">
                <weixinLogin v-if="isWeixinLogin" @emitWeixinLogin="emitWeixinLogin" />
                <div>
                    <span class="weixinLoginTag" @click="handleWeixinLogin"
                        ><img
                            style="width: 18px"
                            src="../../../static/images/weixinLogo.png"
                            alt=""
                        />微信</span
                    >
                    <h2>登录</h2>
                    <a-form :form="form">
                        <a-form-item :wrapper-col="formItemLayout.wrapperCol">
                            <a-input
                                class="border-bottom"
                                ref="username"
                                v-decorator="[
                                    'phone',
                                    {
                                        rules: [
                                            { required: true, message: '请输入手机号' },
                                            {
                                                pattern: '^1\\d{10}$',
                                                message: '请输入正确的11位手机号',
                                            },
                                        ],
                                    },
                                ]"
                                placeholder="请输入手机号"
                                @keyup.enter="check"
                                autocomplete="off"
                            />
                        </a-form-item>
                        <a-form-item :wrapper-col="formItemLayout.wrapperCol">
                            <a-input
                                class="border-bottom"
                                ref="password"
                                type="password"
                                v-decorator="[
                                    'password',
                                    { rules: [{ required: true, message: '请输入密码' }] },
                                ]"
                                placeholder="请输入密码"
                                @keyup.enter="check"
                                autocomplete="new-password"
                            />
                        </a-form-item>
                        <a-form-item
                            class="margin-top-30"
                            :label-col="formItemLayout.labelCol"
                            :wrapper-col="formItemLayout.wrapperCol"
                        >
                            <!-- <a-button type="default" :style="{borderColor:globalLess.primaryBorderColor,color:globalLess.primaryColor}" class="my-btn" @click="toRegister"> -->
                            <a-button type="default" class="my-btn" @click="toRegister">
                                还没有账号，去注册
                            </a-button>
                            <!-- <a-button type="primary" :style="{backgroundColor:globalLess.primaryColor,borderColor:globalLess.primaryBorderColor}" class="my-btn fr" @click="check"> -->
                            <a-button type="primary" class="my-btn fr" @click="check">
                                登录
                            </a-button>
                        </a-form-item>
                        <a-form-item
                            :label-col="formItemLayout.labelCol"
                            :wrapper-col="formItemLayout.wrapperCol"
                        >
                            <a-button type="link" class="fr" @click="toReset"> 忘记密码 </a-button>
                        </a-form-item>
                    </a-form>
                </div>
            </div>
        </div>

        <a-config-provider :locale="zhCN">
            <a-modal
                v-model="modelVisible"
                title="温馨提示"
                :closable="false"
                :keyboard="false"
                :maskClosable="false"
            >
                <p>请进行微信授权登录，完善个人信息！</p>
                <template #footer>
                    <a-button key="submit" type="primary" @click="handleModelVisibleOk"
                        >确定</a-button
                    >
                </template>
            </a-modal>
        </a-config-provider>
        <a-modal v-model="visible" title="访问受限" :maskClosable="false">
            <p>请于本省内进行访问</p>
            <p>申请暂时解除限制请联系</p>
            <p>0431-81884046</p>
            <template slot="footer">
                <a-button key="back" @click="outLogin">退出</a-button>
                <!-- <a-button key="submit" type="primary" @click="apply">
          申请解除
        </a-button> -->
            </template>
        </a-modal>
    </div>
</template>

<script>
    import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN' // 汉化
    import ajax from '@/api/ajax'
    import { apiListPC } from '@/api'

    import weixinLogin from '@/components/LoginRelated/weixinLogin/weixinLogin'

    import md5 from 'js-md5'
    const formItemLayout = {
        wrapperCol: { span: 24, offset: 0 },
    }
    export default {
        name: 'Login',
        data() {
            return {
                formItemLayout,
                form: this.$form.createForm(this),
                zhCN,
                isWeixinLogin: false,
                modelVisible: false,
                visible: false,
                ipValue: '',
                addressValue: '',
            }
        },
        components: {
            weixinLogin,
        },
        created() {
            sessionStorage.setItem('QQOrWeiXin', '1')
            localStorage.setItem('token', '')
        },
        mounted() {
            this.bus.$emit('loading', false)
            this.$store.commit('saveLicense', sessionStorage.getItem('license'))

            // 如果有code 证明是微信二维码登录
            let winUrl = window.location.href
            if (this.GetQueryString('code', winUrl) != undefined) {
                const errCodeList = ['1002', '1003', '1004']

                // 200证明登录成功
                if (this.GetQueryString('code', winUrl) == 200) {
                    if (this.GetQueryString('loginStatus', winUrl) == '1') {
                        localStorage.setItem('token', this.GetQueryString('token', winUrl))
                        this.$message.success('登录成功')
                        this.$store.commit('changeLoginTrue')
                        this.$router.replace('/Select')
                    }
                    if (
                        this.GetQueryString('loginStatus', winUrl) == '0' ||
                        this.GetQueryString('loginStatus', winUrl) == '2'
                    ) {
                        this.GetQueryString('loginStatus', winUrl) == '0' &&
                            sessionStorage.setItem(
                                'tokenWeixin',
                                this.GetQueryString('token', winUrl)
                            )
                        this.GetQueryString('loginStatus', winUrl) == '2' &&
                            localStorage.setItem('token', this.GetQueryString('token', winUrl))

                        sessionStorage.setItem(
                            'loginStatus',
                            this.GetQueryString('loginStatus', winUrl)
                        )

                        sessionStorage.setItem('QQOrWeiXin', '2')
                        this.$store.commit('changeLoginTrue')
                        setTimeout(() => {
                            this.$router.replace('/Register')
                        }, 10)
                    }
                    if (this.GetQueryString('loginStatus', winUrl) == '3') {
                        localStorage.setItem('token', this.GetQueryString('token', winUrl))
                        this.$router.replace('/Login')
                        this.visible = true
                    }
                } else if (this.GetQueryString('code', winUrl) == '1001') {
                    this.$message.error('网页版不允许使用，服务到期!')
                    this.$router.replace('/Login')
                } else if (errCodeList.includes(this.GetQueryString('code', winUrl))) {
                    this.$message.error('微信授权失败!')
                    // console.log(this.GetQueryString('code', winUrl), '微信授权失败')
                    this.$router.replace('/Login')
                } else {
                    this.$message.error('微信扫码登录失败!')
                    this.$router.replace('/Login')
                }
            }
            // console.log(this.$store.state.license, '登录页的saveLicense')
            sessionStorage.removeItem('weixinLoginHerf')
        },
        methods: {
            // saveIp() {
            //   // eslint-disable-next-line no-undef
            //   this.$store.commit("saveIp", this.ipValue);
            //   // eslint-disable-next-line no-undef
            //   this.$store.commit("saveAddress", this.addressValue);
            //   console.log(this.$store.state.ip, this.$store.state.address, "改了吗");
            // },
            //申请解禁
            apply() {
                let sendData = {
                    ip: this.$store.state.ip,
                    token: localStorage.getItem('token'),
                }
                ajax(apiListPC.relieveIp, sendData, 'POST').then((res) => {
                    if (res) {
                        this.$store.commit('changeLoginTrue')
                        this.$router.replace('/Select')
                    }
                })
            },
            outLogin() {
                this.visible = false
                const isLoginRoute = this.$route.path || ''
                !isLoginRoute.includes('/Login') && this.$router.replace('/Login')
            },
            check() {
                let that = this
                that.form.validateFields((err) => {
                    if (!err) {
                        that.bus.$emit('loading', true)
                        let sendData = {
                            // 'username': that.$refs.username.value,
                            password: md5(that.$refs.password.value).toUpperCase(),
                            phone: that.$refs.username.value,
                            license: that.$store.state.license,
                            // ip: that.$store.state.ip,
                            // address: that.$store.state.address,
                        }
                        // let res = login('user/login',sendData,'POST');
                        let res = ajax(apiListPC.login, sendData, 'POST')
                        res.then(function (data) {
                            that.bus.$emit('loading', false)
                            // // 老客户登录PC端网址，手机号登录成功后，弹出提示语功能
                            // if (true) {
                            //   that.modelVisible = true
                            //   return false
                            // }
                            if (data.data.loginStatus == '1') {
                                that.$message.success('登录成功！')
                                //每次登录成功以后 将返回来的token存起来 在每次发起请求时 需要带上token作为校验信息
                                localStorage.setItem('token', data.data.token)
                                that.$router.replace('/Select')
                            }
                            if (data.data.loginStatus == '0') {
                                that.$router.replace('/Register')
                            }
                            if (data.data.loginStatus == '2') {
                                that.$store.commit('changeLoginTrue')
                                sessionStorage.setItem('QQOrWeiXin', '2')
                                setTimeout(() => {
                                    that.$router.replace('/Register')
                                }, 10)
                            }
                            if (data.data.loginStatus == '3') {
                                localStorage.setItem('token', data.data.token)
                                that.visible = true
                            }
                        }).catch(function (data) {
                            that.bus.$emit('loading', false)
                            that.$message.error(data.returnInfo)
                        })
                    }
                })
            },
            toRegister() {
                sessionStorage.setItem('QQOrWeiXin', '1')
                this.$router.push('/Register')
            },
            toReset() {
                this.$router.push('/Reset')
            },
            // 获取地址栏参数
            GetQueryString(name, url) {
                return (
                    decodeURIComponent(
                        (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [
                            '',
                            '',
                        ])[1].replace(/\+/g, '%20')
                    ) || undefined
                )
            },
            handleWeixinLogin() {
                this.bus.$emit('loading', false)
                this.isWeixinLogin = true
            },
            emitWeixinLogin(_val) {
                this.isWeixinLogin = _val
                this.bus.$emit('loading', false)
            },
            handleModelVisibleOk() {
                this.handleWeixinLogin()
                this.modelVisible = false
            },
        },
    }
</script>

<style lang="less" type="text/less" scoped>
    .login-bg {
        width: 100%;
        height: 100vh;

        .login-left {
            width: 605px;
            height: 100%;
            background: url('../../../static/images/bg-4.jpg');
            float: left;
            position: relative;

            img {
                width: 50px;
                height: 50px;
                position: absolute;
                left: 40px;
                top: 40px;
            }
            .clienteleName {
                position: absolute;
                left: 100px;
                top: 40px;
                line-height: 50px;
                color: white;
                font-size: 24px;
            }

            .login-copyright {
                color: #fff;
                opacity: 0.4;
                font-size: 13px;
                text-align: left;
                text-indent: 40px;
                position: absolute;
                bottom: 30px;
                left: 0;
            }

            .login-info {
                width: 100%;
                height: 100px;
                position: absolute;
                left: 0;
                top: 50%;
                margin-top: -40px;
                padding: 0 40px;
            }

            .login-info-title {
                text-align: left;
                height: 60px;
                line-height: 60px;
                font-size: 30px;
                font-weight: 500;
                color: #fff;
                span {
                    display: inline-block;
                    border: 1px solid #fff;
                    font-size: 14px;
                    color: #fff;
                    border-radius: 2px;
                    line-height: 18px;
                    padding: 0 3px;
                    margin-left: 10px;
                    position: relative;
                    top: -2px;
                }
            }

            .login-info-text {
                text-align: right;
                height: 40px;
                line-height: 40px;
                font-size: 16px;
                font-weight: 200;
                color: #fff;
            }
        }

        .login-right {
            width: calc(100% - 605px);
            height: 100%;
            float: right;
            position: relative;

            .login-box {
                width: 450px;
                height: 500px;
                position: absolute;
                top: 50%;
                left: 50%;
                margin-left: -200px;
                margin-top: -250px;
                .ant-form-item {
                    margin-bottom: 24px;
                }
                h2 {
                    text-align: center;
                    margin-bottom: 0;
                    height: 50px;
                    line-height: 50px;
                    font-weight: 700;
                    letter-spacing: 8px;
                }

                .my-btn {
                    border-radius: 15px;
                    width: 45%;
                    display: inline-block;
                    float: left;
                }

                .fr {
                    float: right;
                }

                .border-bottom {
                    border: none;
                    border-bottom: 1px solid #ddd;
                    border-radius: 0;
                }

                .margin-top-30 {
                    margin-top: 30px;
                    margin-bottom: 12px;
                }
            }
            .weixinLoginTag {
                position: absolute;
                right: 0;
                top: 15px;
                cursor: pointer;
            }
        }
    }
</style>
